(function () {
  'use strict';

  var SUBSCRIBED_KEY = 'folkNewsletterSubscribed';
  var DISMISSED_KEY = 'folkNewsletterDismissedAt';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;

    if (popup.getAttribute('data-preview-mode') === 'true') {
      openPopup(popup);
      bindDismiss(popup);
      return;
    }

    var postedWrap = popup.querySelector('[data-newsletter-form-wrap][data-posted="true"]');
    if (postedWrap) {
      safeSetItem(SUBSCRIBED_KEY, '1');
      openPopup(popup);
      bindDismiss(popup);
      return;
    }

    if (safeGetItem(SUBSCRIBED_KEY) === '1') return;

    var suppressDays = parseFloat(popup.getAttribute('data-suppress-days')) || 7;
    var dismissedAt = parseInt(safeGetItem(DISMISSED_KEY), 10);
    if (dismissedAt) {
      var elapsedMs = Date.now() - dismissedAt;
      var suppressMs = suppressDays * 24 * 60 * 60 * 1000;
      if (elapsedMs < suppressMs) return;
    }

    bindDismiss(popup);
    scheduleTrigger(popup);
  }

  function scheduleTrigger(popup) {
    var trigger = popup.getAttribute('data-trigger') || 'delay';

    if (trigger === 'scroll_depth') {
      watchScrollDepth(popup);
      return;
    }

    if (trigger === 'exit_scroll') {
      var isFinePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
      if (isFinePointer) {
        watchExitIntent(popup);
      } else {
        watchScrollDepth(popup);
      }
      return;
    }

    var delaySeconds = parseFloat(popup.getAttribute('data-delay')) || 8;
    setTimeout(function () {
      openPopup(popup);
    }, delaySeconds * 1000);
  }

  function watchScrollDepth(popup) {
    var percent = parseFloat(popup.getAttribute('data-scroll-percent')) || 50;
    var opened = false;

    function onScroll() {
      if (opened) return;
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      var scrolled = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;
      if (scrolled >= percent) {
        opened = true;
        window.removeEventListener('scroll', onScroll);
        openPopup(popup);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function watchExitIntent(popup) {
    var opened = false;

    function onMouseOut(event) {
      if (opened) return;
      if (event.clientY > 0) return;
      if (event.relatedTarget) return;
      opened = true;
      document.removeEventListener('mouseout', onMouseOut);
      openPopup(popup);
    }

    document.addEventListener('mouseout', onMouseOut);
  }

  function openPopup(popup) {
    if (popup.classList.contains('is-open')) return;
    popup.hidden = false;
    requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
    document.body.classList.add('newsletter-popup-open');
    startBackgroundVideo(popup);

    var closeButton = popup.querySelector('[data-newsletter-close].newsletter-popup__close');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function backgroundVideo(popup) {
    return popup.querySelector('.newsletter-popup__bg-media video');
  }

  /* The popup markup carries `hidden` until it triggers, so at page load the video sits inside a
     display:none subtree and the browser never honours its `autoplay` attribute. Un-hiding it does
     NOT re-fire autoplay, which is why the background would come up as a frozen first frame. Kick
     playback off explicitly instead, once the popup is genuinely on screen. */
  function startBackgroundVideo(popup) {
    var video = backgroundVideo(popup);
    if (!video) return;

    video.muted = true; // autoplay policies only allow muted playback without a user gesture
    video.playsInline = true; // iOS would otherwise refuse, or hijack into fullscreen

    attemptPlay(video);

    /* Browsers suspend media start while the document is hidden. A time-delay trigger can easily
       fire when the visitor has switched to another tab, which would leave them returning to a
       frozen frame -- so retry once the page is actually on screen again. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      if (!popup.classList.contains('is-open')) return;
      if (!video.paused) return;
      attemptPlay(video);
    });
  }

  function attemptPlay(video) {
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* Blocked (power saver, reduced motion, low battery): the poster frame stays as a
           static background, so the popup still reads correctly. */
      });
    }
  }

  function closePopup(popup) {
    popup.classList.remove('is-open');
    document.body.classList.remove('newsletter-popup-open');
    safeSetItem(DISMISSED_KEY, String(Date.now()));

    var video = backgroundVideo(popup);
    if (video) video.pause();

    setTimeout(function () {
      popup.hidden = true;
    }, 300);
  }

  function bindDismiss(popup) {
    var closers = popup.querySelectorAll('[data-newsletter-close]');
    closers.forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(popup);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup(popup);
      }
    });
  }

  function safeGetItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSetItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* storage unavailable (private mode, etc.) -- fail silently */
    }
  }
})();
